import { BsTriangleFill } from "react-icons/bs";
import { TopScrollBtnContainer } from "./style.button";

const TopScrollButton = (props) => {

    return (
        <TopScrollBtnContainer 
            width={props.width}
            margin={props.margin}
            fontSize={props.fontSize}
            gap={props.gap}
            color={props.color}
            onClick={props.handleOnClick}>
                
                <BsTriangleFill/>
                <div>{props.label}</div>

        </TopScrollBtnContainer>
    );
}

export default TopScrollButton;